<template>
  <router-link :to="`/properties?cities=${city.areas.join(',')}`">
    <div class="featured-city" :style="`background: url('/${city.image}');`">
      <div class="overlay">
        <div class="absolute bottom-0 pb-8 text-center w-full text-white">
          <h4 class="mb-1 font-bold">{{city.name}}</h4>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ["city"],
};
</script>

<style lang="scss" scoped>
.featured-city {
  @apply relative rounded-lg;

  height: 350px;
  background-size: cover !important;
  background-position: center !important;

  .overlay {
    @apply absolute w-full bottom-0 rounded-b-lg;
    height: 244px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.01) 0%,
      rgba(29, 41, 62, 1) 100%
    );
  }
}
</style>